import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from 'components/Common/Breadcrumb';
import { MetaTags } from 'react-meta-tags';
import { AppConfiguration } from "config";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerIncidents } from "store/admin/status-monitor/actions";
import { customSortCaret } from "helpers/bootstrap_table_helper";
import { createDefaultColumnSortedObject, forColumnHeaderWrapper } from "helpers/sf_utils";
import { format, parseISO } from "date-fns";
import SfLoadingSkeleton from "components/Common/Loadings/SfLoadingSkeleton";
import { CUSTOMER_INCIDENT_ERROR_STATE } from "helpers/sf_constants";

const AllCustomerIncidents = () => {

    const [customerIncidents, setCustomerIncidents] = useState([])
    const dispatch = useDispatch();

    const { customer_incidents, isLoading, error } = useSelector(state => ({
        customer_incidents: state.StatusMonitor.customer_incidents,
        isLoading: state.StatusMonitor.isLoading,
        error: state.StatusMonitor.error
    }));

    useEffect(() => {
        dispatch(getCustomerIncidents());
    }, [dispatch]);
    
    const customerIncidentsColumns = [
        {
          text: "id",
          dataField: "id",
          sort: true,
          hidden: true,
        },
        {
            text: "Status",
            dataField: "status",
            sort: true,
            headerFormatter: forColumnHeaderWrapper,
            hasInfoTooltip: true,
            tooltipDescription: 'What is the severity of the issue?',
            formatter: (_cellContent, row, _rowIndex) => {
                return (
                        <i className={`mdi mdi-circle font-size-16 ${row?.status  === CUSTOMER_INCIDENT_ERROR_STATE.CRITICAL ? 'status-dot-critical' : row?.status  === CUSTOMER_INCIDENT_ERROR_STATE.ERROR ? 'status-dot-error' : 'status-dot-warning'}`} />
                )
            }
        },
        {
          text: "Reported on",
          dataField: "reported_at",
          sort: true,
          formatter: (_cellContent, row, _rowIndex) => {
              const date = row?.reported_at ? parseISO(row?.reported_at) : null;
              return (
                <div className="d-flex gap-3 justify-content-start">
                      {date ? format(date, "MMM dd yyyy") : "N/A"}
                </div>
              )
          }
        },
        {
          text: "Title",
          dataField: "title",
          sort: true,
          headerFormatter: forColumnHeaderWrapper,
        },
        {
          text: "Description",
          dataField: "description",
          sort: true,
          headerFormatter: forColumnHeaderWrapper,
        },
      ];

      const defaultSorted = [
        createDefaultColumnSortedObject('reported_at', 'asc'),
      ];

    return (
        <React.Fragment>
            <div className="page-content" id="page-content-wrapper">
                <MetaTags>
                    <title>Customer Incidents | {AppConfiguration.WEBSITE}</title>
                </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="" backOption={true} link="/status-monitor" breadcrumbItem="Customer Incidents" />
                    <Row className="mt-3">
                        <Col className="col-12">
                        <Card>
                            <CardBody>
                            <ToolkitProvider
                                keyField="id"
                                columns={customerIncidentsColumns}
                                data={customer_incidents || []}
                            >
                                {(toolkitProps) => (
                                <>
                                    <Row className={`sfTable-Container-for-creatives-campaigns table-responsive`}>
                                    <Col>
                                        {(isLoading) ? (
                                        <SfLoadingSkeleton rows={8} cols={customerIncidentsColumns?.length} />
                                        ) : 
                                        <BootstrapTable
                                            keyField="id"
                                            responsive
                                            bordered={false}
                                            striped={false}
                                            defaultSorted={defaultSorted}
                                            rowClasses="tr-hover"
                                            classes="table table-nowrap text-black"
                                            headerClasses='sftableHeader align-middle text-black'
                                            headerWrapperClasses="thead-light"
                                            noDataIndication={!isLoading && "Loading... please wait"}
                                            {...toolkitProps.baseProps}
                                            sort={{ sortCaret: customSortCaret }}
                                        />
                                        }
                                    </Col>
                                    </Row>
                                </>
                                )}
                            </ToolkitProvider>
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default AllCustomerIncidents